import axios from "axios";

const instance = axios.create({
  baseURL: "http://localhost:5001/clone-react-8ecea/us-central1/api",
});

export const positionStackInstance = (apiKey, lat, lng) =>
  axios.create({
    baseURL: `http://api.positionstack.com/v1/reverse?access_key=${apiKey}&query=${lat},${lng}&limit=1`,
  });
export default instance;
